import styled from "@emotion/styled";
import { TextField } from "react-aria-components";
import { Theme } from "@emotion/react";
import { MDSTextFieldColor } from "./text-field.types";

export const StyledTextField = styled(TextField)<{ color?: MDSTextFieldColor }>`
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};

  width: 100%;
  min-height: 40px;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};

  border: 1px solid ${({ theme, color }) => getBorderColor(theme, color)};
  border-radius: ${({ theme }) => theme.borderRadius.mediumLarge}px;
  background-color: ${({ theme, color }) => getBackgroundColor(theme, color)};
  transition: all 0.2s ease;
  outline: none;

  &:hover:not([data-disabled]):not([data-invalid]) {
    border-color: ${({ theme }) => theme.colors.grey.x300};
  }

  &:focus-within:not([data-disabled]):not([data-invalid]) {
    border-color: ${({ theme }) => theme.colors.blue.x200};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.grey.x25};
  }

  &[data-disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &[data-invalid] {
    border-color: ${({ theme }) => theme.colors.red.x500};
  }

  input {
    flex: 1;
    border: none;
    background: transparent;
    color: ${({ theme }) => theme.colors.grey.x600};
    font-size: ${({ theme }) => theme.fontSizes.medium};
    line-height: ${({ theme }) => theme.lineHeights.medium};
    outline: none;

    &::placeholder {
      color: ${({ theme, color }) => getPlaceholderColor(theme, color)};
    }

    &:disabled {
      cursor: not-allowed;
    }
  }

  textarea {
    flex: 1;
    border: none;
    background: transparent;
    color: ${({ theme }) => theme.colors.grey.x600};
    font-size: ${({ theme }) => theme.fontSizes.medium};
    outline: none;
    resize: none;
    &::placeholder {
      color: ${({ theme, color }) => getPlaceholderColor(theme, color)};
    }

    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const StyledLeftContainer = styled.div<{
  color?: MDSTextFieldColor;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledRightContainer = styled.div<{
  color?: MDSTextFieldColor;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
`;

const getBorderColor = (theme: Theme, color?: MDSTextFieldColor) => {
  switch (color) {
    case MDSTextFieldColor.Red:
      return theme.colors.red.x300;
    default:
      return theme.colors.grey.x100;
  }
};

const getBackgroundColor = (theme: Theme, color?: MDSTextFieldColor) => {
  switch (color) {
    case MDSTextFieldColor.Blue:
      return theme.colors.mblue.x50;
    default:
      return theme.colors.white;
  }
};

const getPlaceholderColor = (theme: Theme, color?: MDSTextFieldColor) => {
  switch (color) {
    case MDSTextFieldColor.Blue:
      return theme.colors.grey.x400;
    default:
      return theme.colors.grey.x300;
  }
};
